import { useEffect, useContext, useState } from "react";
import "./spinwheel.css";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import useSound from 'use-sound';
import wheelRolling from '../../music/wheel-rolling.mp3';
import congrats from '../../music/congrats.mp3';
import { LanguageContext } from "../../context/language/LanguageContext";
import { TenantContext } from "../../context/tenant/TenantContext";
import { ClientContext } from "../../context/client/ClientContext";
import { offerwallapi } from "../../config/axiosconfig";
import { Spinner, Button } from 'react-bootstrap';
import useNetworkStatus from "./hooks/UseNetworkStatus";
import Alert from 'react-bootstrap/Alert';
import CryptoJS from 'crypto-js';


export default function SpinWheel() {

    const { isOnline } = useNetworkStatus();
    const { language } = useContext(LanguageContext);
    const navigate = useNavigate();
    const [wheelPlay, wheelExposedData] = useSound(wheelRolling);
    const [congratsPlay] = useSound(congrats);
    const { tenant } = useContext(TenantContext);
    const { client } = useContext(ClientContext);
    const [isReady, setIsReady] = useState(true);
    const [rewardData, setRewardData] = useState(null);
    const [show, setShow] = useState(false);
    const [reward, setReward] = useState('');
    const [spining, setSpining] = useState(false);
    const [spinStarted, setSpinStarted] = useState(false);
    const [ambassador, setAmbassador] = useState('');
    const [loader, setLoader] = useState(true);
    const params = useParams();
    const tenanturl = params.tenanturlpathname;

    const location = useLocation()
    const { campaignId } = location.state? location.state : {}

    useEffect(() => {
        if (client && tenant) {
            fetchReward();
        }
    }, [tenant, client]);

    useEffect(()=> {
       if(!campaignId){
        client ? navigate(`/${tenanturl}`) : navigate(`/${tenanturl}/signin`);
       }
    }, [])

    useEffect(()=> {
        if(isOnline) setShow(false);
        else setShow(true);
    }, [isOnline])

    const reCheckReward = async () => {
        let info = {
            campaignId: campaignId,
            tenantid: tenant.tenantid,
            clientid: client.clientid
        }
        const res = await offerwallapi.post("/api/gamification/pick-reward", info);
        if (res.status === 200) {
            var decryptedData = await decryptObject(res.data.encryptedData);
            return decryptedData.r;
        }
        return '';
    }

    // Decrypts an encrypted string back into a JavaScript object
    const  decryptObject = async (encryptedString) => {
        const bytes = CryptoJS.AES.decrypt(encryptedString, process.env.REACT_APP_SECRET_KEY);
        const decrypted = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(decrypted);
    }

    const fetchReward = async () => {
        setLoader(true);
        let info = {
            campaignId: campaignId,
            tenantid: tenant.tenantid,
            clientid: client.clientid
        }
        const res = await offerwallapi.post("/api/gamification/pick-reward", info);
        if (res.status === 200) {
            setIsReady(false);
            var decryptedData = await  decryptObject(res.data.encryptedData);
            setRewardData(decryptedData);
            setReward(parseInt(decryptedData.r));
            setAmbassador(decryptedData.ri.ambassadors[randomNumber(0, decryptedData.ri.ambassadors.length)])
            setLoader(false);
            return decryptedData;
        }
        setLoader(false);
        return '';
    }

    const issueReward = async () => {
        let info = {
            campaignId: campaignId,
            tenantid: tenant.tenantid,
            transactionId: rewardData.ti,
            rewardAmount: reward,
            clientid: client.clientid,
            analytics: {
                action: "Spin the Wheel",
                externaluserid: client ? client.externaluserid : "",
                tenantid: tenant?.tenantid,
                campaignid: campaignId
            }
        }
        const res = await offerwallapi.post("/api/gamification/reward-issue", info);
        if (res.status === 200 && res.data.status === 200) {}
    }

    const onSpin = async () => {
        setSpinStarted(true);
        let decryptedData = await reCheckReward();
        if (decryptedData !== ''){
            setSpining(true);
            wheelPlay();
            let angle = randomNumber(parseInt(rewardData.p.split('-')[0].trim()) + 5, parseInt(rewardData.p.split('-')[1].trim()) - 5);
            window.spin(angle);
            issueReward();
            setTimeout(function () {
                setSpining(false);
            }, 2500);
            setTimeout(function () {
                wheelExposedData.stop();
                navigate(`/${tenanturl}/gamification/congratulation`, {
                    state: {
                        reward: reward,
                        chances: rewardData.asc,
                        campaignId: campaignId,
                        congratsImage: rewardData.ri.congratulation,
                        imageUrl: rewardData.ri[`social-media-${reward}`][language.languageid],
                        tnxId: rewardData.ti
                    }
                });
                congratsPlay();
            }, 9000);
        }
    }

    const randomNumber = (min, max) => {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min)) + min;
    }

    return <>
        {loader ? <div style={{ minHeight: '100vlh' }}> 
            <div className="ow-full-overlay">
                <div className="position-absolute ow-content-center text-center">
                    <Spinner animation="border" backdrop="static" variant="light" />
                </div>
            </div>
        </div> : <div style={{ minHeight: '100vlh' }}>
            {show ? <div style={{ margin: '10px 50px' }}><Alert variant="danger" onClose={() => setShow(false)} dismissible>
                <Alert.Heading>{language?.static_labels.network_connection_error}</Alert.Heading>
                <p>
                    {language?.static_labels.network_connection_error_desc}
                </p>
            </Alert> </div> : null}
            <br />
            <div className="align-center" style={{ color: '#1434CB', fontSize: '26px', fontWeight: 'bold' }}>
                <h3>{language?.static_labels.wheel_spin_campaign}</h3>
            </div>
            <div style={{ fontSize: '18px' }} className="align-center gray-text">
                <span>{language?.static_labels.wheel_spin_campaign_desc_line1} <br /> {language?.static_labels.wheel_spin_campaign_desc_line2}</span>
            </div>
            <div className="wrapper align-center">
                <div>
                    <img style={{ zIndex: -99 }} width={400} src={ambassador} alt="pointer" />
                </div>
                <div style={{ marginTop: '-355px' }}>
                    <div className="pointer-wrapper">
                        <img width={40} className={spining ? 'vibrate' : ''} src={rewardData?.ri?.pointer} alt="pointer" />
                    </div>
                    <img width={300} height={300} src={rewardData?.ri?.spinwheel} alt="spping wheel" class="wheel" />
                </div>
            </div>
            <div style={{ marginTop: '5px' }} className="align-center">
                <img width={100} src={require('../../images/wheel-stand.png')} alt="pointer" />
            </div>
            <br />
            <div className="align-center" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                <span>{language?.static_labels.you_can_spin_wheel_for}</span><span style={{ color: '#1434CB', fontSize: '30px' }}> {rewardData?.asc} </span><span> {language?.static_labels.times}!</span>
            </div>
            <br />
            <div className="align-center">
                {rewardData?.asc < 1 || spinStarted ? <button style={{
                    paddingLeft: '10px',
                    backgroundColor: '#cccccc', color: '#666666'
                }} className="btn-bg" onClick={null}>
                    <img style={{ float: 'left' }} width={25} src={require('../../images/btn-img-dsbl.png')} alt="pointer" />
                    <span style={{ textAlign: 'center' }} >{language?.static_labels.spin_the_wheel}</span>
                </button> : <button disabled={isReady} style={{ paddingLeft: '10px', backgroundColor: isReady ? '' : '#1434CB' }}
                    className="btn-bg" onClick={() => isOnline ? onSpin() : null}>
                    <img width={25} style={{ float: 'left' }} src={require('../../images/btn-img.png')} alt="pointer" />
                    <span style={{ color: isReady ? 'black' : 'white', textAlign: 'center' }} >{language?.static_labels.spin_the_wheel}</span>
                </button>}

            </div>
            <br />
                <div style={{ margin: '0px 10px' }} className="align-center">
                    {language?.languagecode === 'ja' ?
                        <span>{rewardData?.ri.tnc[language?.languagecode]?.text} <a href={rewardData?.ri.tnc[language?.languagecode]?.link} target="_blank" style={{ color: '#1434CB' }}>{rewardData?.ri.tnc[language?.languagecode] ? rewardData?.ri.tnc[language?.languagecode]['link-text'] : ""}</a></span>
                        : 
                        <span><a href={rewardData?.ri.tnc[language?.languagecode]?.link} target="_blank" style={{ color: '#1434CB' }}>{rewardData?.ri.tnc[language?.languagecode] ? rewardData?.ri.tnc[language?.languagecode]['link-text'] : ""}</a> {rewardData?.ri.tnc[language?.languagecode]?.text}</span>
                    }
            </div>
            <br />
        </div>
        }
    </>
}